import collUtil from "./collUtil";
import commonUtil from "./commonUtil";
import dateUtil from "./dateUtil";
import websocketUtil from "./socket/websocketUtil";
// 注册普通js全局基本方法

// 注册vue实例的全局基本方法
export default {
  install(Vue) {
    // 注册普通js全局基本方法
    set(window, null, collUtil.methods)
    let map = {
      collUtil,
      commonUtil,
      websocketUtil,
      dateUtil,
    };
    for (let key in map) {
      let util = map[key];
      Vue.mixin(util);
      Vue.prototype[key] = util.methods;
    }
  },
};

function set(target, targetSubPropName, resourceParent) {
  let newTarget;
  if (targetSubPropName == null) {
    newTarget = target;
  } else {
    newTarget = target[targetSubPropName];
    if (newTarget == null) {
      newTarget = {};
      target[targetSubPropName] = newTarget;
    }
  }
  for (const methodName in resourceParent) {
    if (newTarget.hasOwnProperty(methodName)) {
      const msg =
        `set value fail|target.hasOwnProperty=true|methodName=` + methodName;
      throw msg;
    } else {
      newTarget[methodName] = resourceParent[methodName];
    }
  }
}
